module.exports = __webpack_public_path__ + "static/leaveEarly.e29d876e.svg";